import { Link } from 'react-router-dom';
import LogoDark  from 'src/assets/images/logos/logo-1.5.jpg';
import { styled } from '@mui/material';

const LinkStyled = styled(Link)(() => ({
  height: '70px',
  width: '180px',
  overflow: 'hidden',
  display: 'block',
}));

const Logo = () => {
  return (
    <LinkStyled to="/">
      <img height="auto" width={200} src={LogoDark} style={{marginTop:"-35px"}} alt="Logo Earnpati"/>
    </LinkStyled>
  )
};

export default Logo;
